import type {ComponentPropsWithoutRef, ElementType, ReactElement, ReactNode} from 'react';
import {clsx} from 'clsx';
import styles from './index.module.scss';

interface Props<T> {
    className?: string;
    as?: T;
    children: ReactNode;
}

export default function TextButton<T extends ElementType = 'button'>({
    children,
    className,
    as,
    ...rest
}: Props<T> & Omit<ComponentPropsWithoutRef<T>, keyof Props<T>>): ReactElement<Props<T>> {
    const classNames = clsx({
        [styles.element]: true,
        [className as string]: className,
    });

    const Component = as ?? 'button';

    return (
        <Component className={classNames} {...rest}>
            {children}
        </Component>
    );
}
